export default __webpack_public_path__ + "images/hiring-card.558de6ee3ce6c59d4985.png";